module.exports = __webpack_public_path__ + "img/6.c8609a8f.jpg";